// @ts-expect-error ContentEditorUI util not yet migrated
import { isPublishedState } from 'ContentEditorUI/utils/publishUtils';
import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
import Routes from 'ContentUtils/Routes';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIsUngatedForPersonalizationVariants } from '../redux/selectors/authSelectors';
import { getHasPersonalizedVariants, getIsPersonalizedVariant } from '../redux/selectors/pageContentModelSelectors';
import { useFetchPersonalizationVariants } from './useFetchPersonalizationVariants';
import { jsx as _jsx } from "react/jsx-runtime";
export const usePersonalizationPublishValidation = contentId => {
  const isPersonalizedVariant = useSelector(getIsPersonalizedVariant);
  const isPersonalizationDefault = useSelector(getHasPersonalizedVariants);
  const isUngatedForPersonalizationVariants = useSelector(getIsUngatedForPersonalizationVariants);
  const {
    data,
    loading,
    error
  } = useFetchPersonalizationVariants({
    contentId,
    shouldFetch: isUngatedForPersonalizationVariants && (isPersonalizedVariant || isPersonalizationDefault)
  });
  const {
    isPublishDisabledDueToPersonalization,
    isUnpublishDisabledDueToPersonalization,
    personalizationDefaultPageId,
    personalizationDefaultPageName
  } = useMemo(() => {
    const metaData = {
      isPublishDisabledDueToPersonalization: false,
      isUnpublishDisabledDueToPersonalization: false,
      personalizationDefaultPageId: undefined,
      personalizationDefaultPageName: undefined
    };
    const allVariants = (data === null || data === void 0 ? void 0 : data.personalizationVariants) || [];
    if (data && !loading && !error) {
      if (isPersonalizedVariant) {
        // A personalized variant should not be published if its parent is not published
        const personalizationDefault = allVariants.find(({
          personalizationVariantStatus
        }) => personalizationVariantStatus === 'DEFAULT');
        metaData.isPublishDisabledDueToPersonalization = !isPublishedState(personalizationDefault === null || personalizationDefault === void 0 ? void 0 : personalizationDefault.state);
        metaData.personalizationDefaultPageId = personalizationDefault === null || personalizationDefault === void 0 ? void 0 : personalizationDefault.id;
        metaData.personalizationDefaultPageName = personalizationDefault === null || personalizationDefault === void 0 ? void 0 : personalizationDefault.name;
      } else if (isPersonalizationDefault) {
        // A personalization default should not be unpublished if any of its variants are published
        metaData.isUnpublishDisabledDueToPersonalization = allVariants.filter(({
          personalizationVariantStatus
        }) => personalizationVariantStatus !== 'DEFAULT').some(({
          state
        }) => isPublishedState(state));
      }
    }
    return metaData;
  }, [data, loading, error, isPersonalizedVariant, isPersonalizationDefault]);
  const variantPublishDisabledMessage = useMemo(() => {
    if (!isPublishDisabledDueToPersonalization || !personalizationDefaultPageId || !personalizationDefaultPageName) {
      return null;
    }
    const href = Routes.edit(personalizationDefaultPageId, CATEGORY_IDS.LANDING_PAGE);
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "personalizationPublishValidation.cannotPublishVariant_jsx",
      elements: {
        Link
      },
      options: {
        linkProps: {
          href
        },
        pageName: personalizationDefaultPageName
      }
    });
  }, [isPublishDisabledDueToPersonalization, personalizationDefaultPageId, personalizationDefaultPageName]);
  return {
    isPublishDisabledDueToPersonalization,
    isUnpublishDisabledDueToPersonalization,
    isPersonalizationFetchLoading: loading,
    variantPublishDisabledMessage
  };
};